import React, { useState } from "react";
import { Button } from "react-bootstrap";

function RemiseMembre({ membresBureau, remiseMembre, changeRemiseMembre }) {
  const [remiseMembreBureau, setRemiseMembreBureau] = useState(remiseMembre);
  return membresBureau.map((membre, index) => {
    return (
      <Button
        key={index}
        style={{ height: "35px" }}
        variant="secondary"
        className={
          remiseMembreBureau && membre.uid === remiseMembreBureau.uid
            ? "buttonChecked"
            : ""
        }
        onClick={() => {
          setRemiseMembreBureau(membre);
          changeRemiseMembre(membre);
        }}
      >
        {membre.displayName}
      </Button>
    );
  });
}

export default RemiseMembre;
